<template>
    <OverlayLoader :isLoading="!connectionLoaded || !productsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="`${this.$translate.text('clients.connections.all_products')} ( ${connection.name} )`"
                    icon="fal fa-search"
                    @catchEmit="toggleSearch"
                />

                <ProductMenu></ProductMenu>

                <WhiteTable
                    v-if="!productsLoading"
                    @changePage="changePage"
                    :showPaginate="true"
                    :paginate="paginate"
                    :customth="true"
                    :showSelectAll="false"
                    :selectLabel="$translate.text('clients.connections.product.select.all')"
                    @selectEverything="selectAll"
                >
                    <template slot="table-header">

                        <tr>
                            <th>{{$translate.text('clients.connections.product.name')}}</th>
                            <th>{{$translate.text('clients.connections.product.number')}}</th>
                            <th>{{$translate.text('clients.connections.product.category')}}</th>
                            <th>{{$translate.text('clients.connections.product.pricing')}}</th>
                            <th>{{$translate.text('general.status')}}<i ref=button @click="isOpen = !isOpen" style="font-size:14px; padding-left:10px;"  :class="{'fas fa-filter' : filterActive, 'far fa-filter': !filterActive}"></i>
                                <div v-if="isOpen" ref="test">
                                    <ul
                                        class="filterUL"
                                        v-closable="{
                                            exclude: ['button'],
                                            handler: 'handleClickOutside'
                                        }"
                                    >
                                        <li v-for="(status, index) in statusses" :key="index" @click="toggleFilter(status)" class="pointer" style="display: flex;">
                                            <i
                                                :class="{ 'fas fa-check-square' : status.active, 'fal fa-square' : !status.active}"
                                                style="color:white; margin:0px 10px; width: 20px;"
                                            />
                                            <span>{{status.name}}</span>
                                        </li>
                                        <li class="pointer" @click="resetFilters" style="display: flex;">
                                            <i class="fal fa-times" style="color:white; margin:0px 10px; width: 20px;"></i>
                                            <span>{{$translate.text('filters.remove')}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </th>
                        </tr>

                    </template>
                    <template slot="table-data">
                        <tr v-for="product in products" :key="product.id" :class="{ product_attention: product.is_modified && product.in_sync, product_requires_sync: !product.in_sync }">
                            <td>
                                <input
                                    type="checkbox"
                                    v-model="selectedProducts"
                                    :value="product.id"
                                    @click="selectItem($event, product)"
                                    v-if="true === false"
                                >
                                {{ product.name }}
                            </td>
                            <td>{{ product.unique_code }}</td>
                            <td>{{ product.connection_category ? product.connection_category.feed_name : ''}}</td>
                            <td>&euro; {{ product.price }}</td>
                            <td>
                                <i v-if="!product.in_sync" class="fal fa-sync red" v-tooltip.bottom="$translate.text('tooltip.product.requires_sync')"></i>
                                <i v-else-if="product.is_modified" class="fal fa-question yellow" v-tooltip.bottom="$translate.text('tooltip.product.is_modified')"></i>
                            </td>
                            <td>
                            </td>
                            <td class="align-right">
                                <i class="fal fa-edit" @click="$router.push({ name: 'Clients Connections Products Edit', params: { id: connectionId, productId: product.id } })"></i>
                            </td>
                        </tr>
                        <tr v-if="!products.length">
                            <td colspan="6">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
                <div class="overlay-loader" v-else>
                    <div class="spinner"></div>
                </div>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>


// Helpers
import handleError from '@/helpers/error';
import selectAll from '@/helpers/selector';


import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';

import ProductMenu from '@/components/ProductsMenu/ProductMenu';


export default {
    name: 'ClientsConnectionsProducts',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        ProductMenu,
    },

    data() {
        return {
            connection: {},
            connectionLoaded: false,

            products: {},
            productsLoaded: true,
            productsLoading: false,

            selectedProducts: [],
            allProductsSelected: false,
            connectionId: null,
            isOpen: false,

            filters: {
                search: null,
                filter: {
                    status: [],
                },
            },

            statusses: {
                waiting: {
                    name: this.$translate.text('filters.waiting.sync'),
                    value: 'Waiting for sync',
                    active: false,
                },
                adjusted: {
                    name: this.$translate.text('filters.adjusted.synced'),
                    value: 'Adjusted and synced',
                    active: false,
                },
                adjusted_show: {
                    name: this.$translate.text('filters.adjusted.show'),
                    value: 'adjusted_show',
                    active: false,
                },
                adjusted_name: {
                    name: this.$translate.text('filters.adjusted.name'),
                    value: 'adjusted_name',
                    active: false,
                },
                adjusted_price: {
                    name: this.$translate.text('filters.adjusted.price'),
                    value: 'adjusted_price',
                    active: false,
                },
                adjusted_unique_code: {
                    name: this.$translate.text('filters.adjusted.unique_code'),
                    value: 'adjusted_unique_code',
                    active: false,
                },
                adjusted_category: {
                    name: this.$translate.text('filters.adjusted.category'),
                    value: 'adjusted_category',
                    active: false,
                },
                adjusted_additional_categories: {
                    name: this.$translate.text('filters.adjusted.additional_categories'),
                    value: 'adjusted_additional_categories',
                    active: false,
                },
                adjusted_seo: {
                    name: this.$translate.text('filters.adjusted.seo'),
                    value: 'adjusted_seo',
                    active: false,
                },
            },

            paginate: {
                current_page: 1,
            },
        };
    },

    created() {
        this.getConnection();
        this.getProducts();
        this.connectionId = this.$route.params.id;
    },

    mounted() {
        this.popupItem = this.$refs.test;
    },

    methods: {
        toggleFilter(filter) {
            filter.active = !filter.active;


            this.filters.filter.status = [];
            Object.keys(this.statusses).forEach(index => {
                if (this.statusses[index].active) {
                    this.filters.filter.status.push(this.statusses[index].value);
                }
            });

            this.paginate.current_page = 1;

            this.getProducts();
        },

        handleClickOutside() {
            if (this.isOpen) {
                this.isOpen = false;
            }
        },

        selectAll(event) {
            // Triggerd from the whiteTable with an emit.
            this.allProductsSelected = !event;
            this.selectedProducts = [];
            this.selectedProducts = selectAll(this.products, this.allProductsSelected);
        },
        selectItem(event, product) {
            // eslint-disable-next-line
            this.selectedProducts.length === this.products.length ? this.allProductsSelected = true : this.allProductsSelected = false;
            this.addToProductArray(product);
        },

        addToProductArray(product) {
            const i = this.selectedProducts.indexOf(product.id);
            if (i !== -1) {
                this.selectedProducts.splice(i, 1);
            } else {
                this.selectedProducts.push(product.id);
            }
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    const connection = response.data.data;

                    connection.active = connection.active === 1;
                    connection.use_variants = connection.use_variants === 1;
                    connection.vat_calculate = connection.vat_calculate === 1;
                    connection.content_provider.active = connection.content_provider.active === 1;

                    connection.stock.clearance_sale = connection.stock.clearance_sale === 1;

                    this.connection = connection;
                    this.connectionLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getProducts() {
            const test = this.filters;
            this.API.clients.connections.products(this.$route.params.id, test, this.paginate.current_page)
                .then((response) => {
                    this.products = response.data.data;
                    this.paginate = response.data.meta;
                    this.productsLoaded = true;
                    this.productsLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        changePage(value) {
            switch (value) {
            case 'next':
                this.paginate.current_page += 1;
                break;
            case 'previous':
                this.paginate.current_page -= 1;
                break;
            default:
                this.paginate.current_page = value;
            }

            this.getProducts();
        },

        toggleSearch(event) {
            if (event === '') {
                event = null;
            }
            this.paginate.current_page = 1;

            this.filters.search = event;
            this.getProducts();
        },

        resetFilters() {
            Object.keys(this.statusses).forEach(index => {
                this.statusses[index].active = false;
            });
            this.paginate.current_page = 1;

            this.filters.filter.status = [];
            this.isOpen = false;

            this.getProducts();
        },
    },

    computed: {
        filterActive() {
            let bool = false;
            if (this.isOpen) {
                return true;
            }
            Object.keys(this.statusses).forEach(index => {
                if (this.statusses[index].active) {
                    bool = true;
                }
            });

            return bool;
        },
    },
};
</script>
<style lang="scss" scoped>
.product_attention td {
    border-bottom: 1px solid #fecb18;
    border-top: 1px solid #fecb18;
}
.product_attention td:first-child {
    border-left: 1px solid #fecb18;
}
.product_attention td:last-child {
    border-right: 1px solid #fecb18;
}

.product_requires_sync td {
    border-bottom: 1px solid #fe1818;
    border-top: 1px solid #fe1818;
}
.product_requires_sync td:first-child {
    border-left: 1px solid #fe1818;
}
.product_requires_sync td:last-child {
    border-right: 1px solid #fe1818;
}

.filterUL {
    // top: 70px;
    right: 0px;
    position: absolute;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding: 0;
    list-style: none;
    width: 320px;
    z-index: 1;
    transition: all 0.3ms ease-in-out;

    li {
        background-color: #A0B3C4;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid white;

        &:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        &:last-child {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            border-bottom: unset;
        }

        a {
            color: black;
            text-decoration: none;
            font-size: 14px;
        }
    }
}
.spinner {
  width: 40px;
  height: 40px;
  margin: 40px auto;
  background-color: $yellow;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}

</style>
